import { render, staticRenderFns } from "./ProductPriceTable.vue?vue&type=template&id=5a2b2b15&scoped=true"
import script from "./ProductPriceTable.vue?vue&type=script&lang=js"
export * from "./ProductPriceTable.vue?vue&type=script&lang=js"
import style0 from "./ProductPriceTable.vue?vue&type=style&index=0&id=5a2b2b15&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a2b2b15",
  null
  
)

export default component.exports